"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getAttribute;
function getAttribute(custom_attributes) {
  if (custom_attributes === undefined) throw Error("Custom attributes s\u0105 puste");
  return function (attributeName) {
    var attribute = custom_attributes.filter(function (attribute) {
      return attribute.attribute_code.toLowerCase() === attributeName.toLowerCase();
    });
    return function (attributeKey) {
      return attribute.length ? attribute[0][attributeKey] : null;
    };
  };
}